import React from "react";

var utl = require('./Utils.js');

const makeQR_URL = (url) => {
  let resURL = 'https://api.qrserver.com/v1/create-qr-code/?size=150x150&data='
  resURL += url
  return resURL
}

function QR() {
  const theURL=makeQR_URL(utl.siteURL())
  return (
    <React.Fragment>
      <img src={theURL} alt="Logo" />
    </React.Fragment>
  )
}

export default QR;